import type { JSX } from "react";
import { cn } from "./cn";

export interface AgentChatMessageProps {
  /** Role label displayed above the bubble */
  readonly roleLabel: string;
  /** Message content */
  readonly content: string;
  /** Whether this is a user message (right-aligned, accent) or assistant (left-aligned, surface) */
  readonly isUser: boolean;
  /** Extra className */
  readonly className?: string;
}

/**
 * A role-labeled chat message bubble for agent conversations.
 */
export function AgentChatMessage({
  roleLabel,
  content,
  isUser,
  className,
}: AgentChatMessageProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex flex-col gap-1 max-w-[80%]",
        isUser ? "self-end items-end" : "self-start items-start",
        className,
      )}
    >
      <div className="text-[10px] text-content-tertiary uppercase tracking-wide">
        {roleLabel}
      </div>
      <div
        className={cn(
          "px-3.5 py-2.5 rounded-lg text-sm leading-relaxed",
          isUser
            ? "bg-accent text-white"
            : "bg-surface-secondary border border-edge text-content",
        )}
      >
        {content}
      </div>
    </div>
  );
}
